import { render, staticRenderFns } from "./tagManage.vue?vue&type=template&id=143e6c7b&scoped=true&"
import script from "./tagManage.vue?vue&type=script&lang=js&"
export * from "./tagManage.vue?vue&type=script&lang=js&"
import style0 from "./tagManage.vue?vue&type=style&index=0&id=143e6c7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e6c7b",
  null
  
)

export default component.exports